import "./SearchStructureSkeleton.scss";

export const SearchStructureSkeleton = () => {
  return (
    <div className="search-structure-skeleton-container">
      {/* Breadcrumb */}
      <div className="search-structure-skeleton-breadcrumb">
        <div className="search-structure-skeleton-breadcrumb-item pulse"></div>
        <div className="search-structure-skeleton-breadcrumb-separator"></div>
        <div className="search-structure-skeleton-breadcrumb-item pulse"></div>
      </div>

      {/* Page title */}
      <div className="search-structure-skeleton-title pulse"></div>

      {/* Description */}
      <div className="search-structure-skeleton-description-structure pulse"></div>

      {/* Search filters and results */}
      <div className="search-structure-skeleton-content">
        {/* Filters column */}
        <div className="search-structure-skeleton-filters">
          <div className="search-structure-skeleton-filter-title pulse"></div>
          <div className="search-structure-skeleton-filter-divider"></div>
          <div className="search-structure-skeleton-filter-items">
            <div className="search-structure-skeleton-filter-item pulse"></div>
            <div className="search-structure-skeleton-filter-item pulse"></div>
            <div className="search-structure-skeleton-filter-item pulse"></div>
          </div>
          <div className="search-structure-skeleton-filter-items">
            <div className="search-structure-skeleton-filter-item pulse"></div>
            <div className="search-structure-skeleton-filter-item pulse"></div>
            <div className="search-structure-skeleton-filter-item pulse"></div>
          </div>
          <div className="search-structure-skeleton-filter-items">
            <div className="search-structure-skeleton-filter-item pulse"></div>
            <div className="search-structure-skeleton-filter-item pulse"></div>
            <div className="search-structure-skeleton-filter-item pulse"></div>
          </div>
        </div>

        {/* Results column */}
        <div className="search-structure-skeleton-results">
          {/* Search input */}
          <div className="search-structure-skeleton-search-input pulse"></div>

          {/* Results map */}
          <div className="search-structure-skeleton-map pulse"></div>
        </div>
      </div>
    </div>
  );
};
